import {
  ICustomerDetailsFilters,
  ICustomerListFilters,
  IDeleteIds,
} from '../../_models/superAdmin/customerManagementInterface'
import { get, post } from '../apiServices'

const getCustomerList = async (filters: ICustomerListFilters) => {
  const response = await get('/super-admin/customer/list', filters)
  return response
}
const getCustomerDetails = async (filters: ICustomerDetailsFilters) => {
  const response = await get('/super-admin/customer/details', filters)
  return response
}

const deleteCustomer = async (ids: IDeleteIds) => {
  const response = await post('/super-admin/customer/delete', ids)
  return response
}

const customerManagementService = {
  getCustomerList,
  getCustomerDetails,
  deleteCustomer,
}

export default customerManagementService
